// Updated CabinetZdoRequests.jsx
import React, { useState, useEffect } from 'react';
import './cabinet-zdo-requests.css';
import { zdoRequestsApi } from './actions';
import arrow_down_fill_svg from '../../../../../img/arrow-down-fill.svg';

const CabinetZdoRequests = ({ kg_id, period, min_age = 2 }) => {
  const MAX_AGE = 8; // Константа максимального возраста
  
  const [activeYearTab, setActiveYearTab] = useState(period);
  const [ageGroups, setAgeGroups] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [requestsData, setRequestsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [showWithoutDeferred, setShowWithoutDeferred] = useState(false);
  const [allRequests, setAllRequests] = useState({});
  const [userHasRequests, setUserHasRequests] = useState(false); // Новое состояние для отображения информации о заявках пользователя
  const [userRequestsCount, setUserRequestsCount] = useState(0); // Количество заявок пользователя

  // Функция для создания последовательности возрастных групп
  const createAgeGroups = (minAge, maxAge) => {
    const groups = [];
    let currentAge = minAge;
    
    // Специальная обработка для min_age = 1.5
    if (minAge === 1.5) {
      // Первая группа: 1.5 - 2 года
      groups.push({
        id: '1.5-2',
        title: 'Вікова група від 1 року 6 місяців до 2 років',
        minAge: 1.5,
        maxAge: 2
      });
      currentAge = 2;
    }
    
    // Создаем группы по одному году для целых чисел
    while (currentAge < maxAge) {
      const nextAge = currentAge + 1;
      const groupId = `${currentAge}-${nextAge}`;
      
      // Форматируем заголовок в зависимости от возраста
      let groupTitle;
      if (currentAge === 1) {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} року`;
      } else if (currentAge >= 2 && currentAge <= 4) {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} років`;
      } else {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} років`;
      }
      
      groups.push({
        id: groupId,
        title: groupTitle,
        minAge: currentAge,
        maxAge: nextAge
      });
      
      currentAge = nextAge;
    }
    
    return groups;
  };

  // Инициализация возрастных групп
  useEffect(() => {
    const groups = createAgeGroups(min_age, MAX_AGE);
    setAgeGroups(groups);
    
    // Инициализируем все группы как развернутые
    const initialExpandedState = {};
    groups.forEach(group => {
      initialExpandedState[group.id] = true;
    });
    setExpandedGroups(initialExpandedState);
  }, [min_age]);

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const handleYearTabClick = (tab) => {
    setActiveYearTab(tab);
    loadRequests(tab);
  };

  // Функция для проверки, является ли заявка відтермінованою
  const isDeferredRequest = (request) => {
    if (!request.preferDateFrom) {
      return false;
    }
    
    const preferDate = new Date(request.preferDateFrom);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    return preferDate > today;
  };

  // Функция фильтрации відтермінованих заявок
  const filterDeferredRequests = (requests) => {
    if (!showWithoutDeferred) {
      return requests;
    }
    
    const filtered = {};
    Object.keys(requests).forEach(groupId => {
      filtered[groupId] = requests[groupId].filter(request => 
        !isDeferredRequest(request)
      );
    });
    
    return filtered;
  };

  // Функция для подсчета общего количества заявок после фильтрации
  const getTotalCountAfterFilter = (filteredRequests) => {
    return Object.values(filteredRequests).reduce((total, groupRequests) => 
      total + groupRequests.length, 0
    );
  };

  // Функция для подсчета заявок пользователя
  const countUserRequests = (requests) => {
    return Object.values(requests).reduce((total, groupRequests) => 
      total + groupRequests.filter(request => request.isMyRequest).length, 0
    );
  };

  const loadRequests = async (period = 'all') => {
    try {
      setLoading(true);
      setError(null);

      // Получаем данные с API - теперь получаем объект с requests и my_requests
      const apiResponse = await zdoRequestsApi.getRequestsToKindergarten(
        kg_id,
        period,
        min_age
      );

      const apiRequests = apiResponse.requests;
      const myRequestsIds = apiResponse.myRequests || [];


      console.log({apiResponse});


      // Фильтруем как в существующих компонентах
      const filteredRequests = zdoRequestsApi.filterRequests(apiRequests, min_age, period);


      // Группируем по возрастам динамически
      const groupedRequests = groupRequestsByDynamicAge(filteredRequests, min_age, MAX_AGE);



      // Преобразуем данные для отображения, передавая массив ID заявок пользователя
      const transformedData = {};
      Object.keys(groupedRequests).forEach(groupId => {
        transformedData[groupId] = zdoRequestsApi.transformRequestsData(
          groupedRequests[groupId], 
          myRequestsIds
        );
      });


      // Сохраняем все заявки
      setAllRequests(transformedData);
      
      // Применяем фильтрацию відтермінованих заявок
      const filteredData = filterDeferredRequests(transformedData);
      setRequestsData(filteredData);
      
      // Обновляем счетчики
      setTotalCount(getTotalCountAfterFilter(filteredData));
      
      // Проверяем наличие заявок пользователя и устанавливаем состояние
      //const userRequestsCount = countUserRequests(filteredData);
      const userRequestsCount = myRequestsIds.length;
      setUserRequestsCount(userRequestsCount);
      setUserHasRequests(userRequestsCount > 0);
      
    } catch (err) {
      console.error('Error loading requests:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Обработчик изменения переключателя
  const handleToggleDeferred = (event) => {
    const isChecked = event.target.checked;
    setShowWithoutDeferred(isChecked);
    
    // Применяем фильтрацию ко всем заявкам
    const filteredData = filterDeferredRequests(allRequests);
    setRequestsData(filteredData);
    
    // Обновляем счетчики
    setTotalCount(getTotalCountAfterFilter(filteredData));
    const userRequestsCount = countUserRequests(filteredData);
    setUserRequestsCount(userRequestsCount);
    setUserHasRequests(userRequestsCount > 0);
  };

  // Динамическая группировка по возрастам с сортировкой
  const groupRequestsByDynamicAge = (requests, minAge, maxAge) => {
    const groups = {};
    
    // Инициализируем все возможные группы
    const allGroups = createAgeGroups(minAge, maxAge);
    allGroups.forEach(group => {
      groups[group.id] = [];
    });

    // Распределяем заявки по группам
    requests.forEach(request => {
      const requestAge = request.ageLimitFrom || 0;
      
      // Находим подходящую группу для заявки
      for (let i = 0; i < allGroups.length; i++) {
        const group = allGroups[i];
        
        // Для группы 1.5-2 проверяем специальные условия
        if (group.id === '1.5-2') {
          if (requestAge >= 1.5 && requestAge < 2) {
            groups[group.id].push(request);
            break;
          }
        } else {
          // Для остальных групп стандартная логика
          if (requestAge >= group.minAge && requestAge < group.maxAge) {
            groups[group.id].push(request);
            break;
          }
        }
      }
    });

    // Сортируем заявки в каждой группе по queueNumber
    Object.keys(groups).forEach(groupId => {
      groups[groupId].sort((a, b) => {
        const queueA = a.queueNumber || Number.MAX_SAFE_INTEGER;
        const queueB = b.queueNumber || Number.MAX_SAFE_INTEGER;
        return queueA - queueB;
      });
    });

    // Удаляем пустые группы
    Object.keys(groups).forEach(groupId => {
      if (groups[groupId].length === 0) {
        delete groups[groupId];
      }
    });

    return groups;
  };

  useEffect(() => {
    if (kg_id && ageGroups.length > 0) {
      loadRequests(activeYearTab);
    }
  }, [kg_id, ageGroups]);

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      accepted: 'queuetable-status-badge-accepted',
      docs: 'queuetable-status-badge-docs',
      selection: 'queuetable-status-badge-selection',
      deleted: 'queuetable-status-badge-deleted',
      pending: 'queuetable-status-badge-pending',
      waiting: 'queuetable-status-badge-waiting',
      'provide-doc': 'queuetable-status-badge-provide-doc',
      selected: 'queuetable-status-badge-selected',
      gathered: 'queuetable-status-badge-gathered',
      rejected: 'queuetable-status-badge-rejected'
    };
    return `queuetable-status-badge ${statusClasses[status] || ''}`;
  };

  const getStatusText = (status) => {
    const statusTexts = {
      accepted: 'Прийнята',
      docs: 'Надання документів',
      selection: 'Обрання садочків',
      deleted: 'Видалена'
    };
    return statusTexts[status] || status;
  };

  // Рендер строки с заявкой
  const renderRequestRow = (request, index, groupId) => {
    const rowClass = request.isMyRequest ? 'table-info' : ''; // Подсветка для заявок пользователя
    
    return (
      <tr key={`${groupId}-${index}`} className={rowClass}>
        <td>
          {request.name}
          {request.isMyRequest && (
            <span 
              className="badge bg-primary ms-2" 
              title="Ваша заявка"
              style={{ fontSize: '0.7em' }}
            >
              ваша
            </span>
          )}
        </td>
        <td>{request.cert}</td>
        <td>{request.submitted}</td>
        <td>{request.sendFrom}</td>
        <td>
          <span className={getStatusBadgeClass(request.status)}>
            {getStatusText(request.status)}
          </span>
        </td>
        <td className="text-truncate" style={{ maxWidth: '340px' }}>
          {request.additional}
        </td>
        <td className="queuetable-actions text-end"></td>
      </tr>
    );
  };

  // Рендер группы
  const renderGroup = (groupId, groupTitle) => {
    const isExpanded = expandedGroups[groupId];
    const groupRequests = requestsData[groupId] || [];

    if (groupRequests.length === 0) {
      return null;
    }

    return (
      <React.Fragment key={groupId}>
        <tr className="queuetable-group-row" data-group={groupId}>
          <td colSpan="7">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-sm btn-link queuetable-collapse-toggle"
                  type="button"
                  aria-label="toggle"
                  aria-expanded={isExpanded}
                  onClick={() => toggleGroup(groupId)}
                >
                  <img src={arrow_down_fill_svg} alt="" />
                </button>
                <div className="queuetable-group-title">
                  {groupTitle}
                </div>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-link p-0 text-body"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  aria-label="Опції групи"
                >
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="dropdown-item" href="#">
                      Сортувати за датою
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Сортувати за іменем
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Експорт CSV
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
        {isExpanded && groupRequests.map((request, index) => 
          renderRequestRow(request, index, groupId)
        )}
      </React.Fragment>
    );
  };

  if (loading) {
    return (
      <main className="queuetable-main-content queuetable-page">
        <div className="container-fluid">
          <div className="queuetable-content-wrapper">
            <div className="text-center py-5">
              <img src="/img/loading.gif" width="100px" alt="Loading..." />
            </div>
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="queuetable-main-content queuetable-page">
        <div className="container-fluid">
          <div className="queuetable-content-wrapper">
            <div className="alert alert-danger">
              Помилка при завантаженні даних: {error}
            </div>
          </div>
        </div>
      </main>
    );
  }


  
  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          

          <div className="queuetable-toolbar-line">
            <div className="queuetable-left d-flex align-items-center gap-2 flex-wrap">
              <div className="dropdown">
                {false && <button
                  className="btn btn-outline-secondary btn-sm dropdown-toggle queuetable-filters-btn"
                  type="button"
                  id="queuetableFiltersBtn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Фільтри не застосовані
                </button>}
                <div className="dropdown-menu p-3" style={{ minWidth: '280px' }}>
                  <div className="mb-2 small text-muted">Статус заявки</div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="accepted" id="queuetableFAccepted" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFAccepted">Прийнята</label>
                  </div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="docs" id="queuetableFDocs" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFDocs">Надання документів</label>
                  </div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="selection" id="queuetableFSelection" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFSelection">Обрання садочків</label>
                  </div>
                  <div className="form-check mb-2">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="deleted" id="queuetableFDeleted" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFDeleted">Видалена</label>
                  </div>
                  <div className="d-flex justify-content-between pt-2 border-top">
                    <button className="btn btn-link btn-sm text-decoration-none" id="queuetableFiltersReset" type="button">
                      Скинути
                    </button>
                    <button className="btn btn-primary btn-sm" id="queuetableFiltersApply" type="button">
                      Застосувати
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="queuetable-right d-flex align-items-center gap-3 flex-wrap">
              <div className="queuetable-search-box position-relative">
                <input
                  id="queuetableRequestsSearch"
                  type="text"
                  className="form-control queuetable-search-input"
                  placeholder="Швидкий пошук"
                  aria-label="Швидкий пошук"
                />
                <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Навчальний  рік</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeYearTab === 'all' ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleYearTabClick('all');
                    }}
                  >
                    Всі
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeYearTab === period ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleYearTabClick(period);
                    }}
                  >
                    {period}-{period + 1}
                  </a>
                </li>
              </ul>
            </div>
            <div className="queuetable-switch-wrap d-flex align-items-center gap-2">
              <span className="text-white-50">Показувати без відтермінованих</span>
              <div className="form-check form-switch m-0">
                <input 
                  className="form-check-input" 
                  type="checkbox" 
                  id="queuetableNoDeferred" 
                  checked={showWithoutDeferred}
                  onChange={handleToggleDeferred}
                />
              </div>
            </div>
          </div>

          {/* Информация о заявках пользователя */}
          {userHasRequests && (
            <div className="alert alert-info mb-4">
              <div className="d-flex align-items-center">
                <i className="fa-solid fa-circle-info me-2"></i>
                <div>
                  <strong>Ваша заявка у цьому навчальному році:</strong> У цьому списку є {userRequestsCount} ваших 
                  {userRequestsCount === 1 ? ' заявка' : 
                   userRequestsCount >= 2 && userRequestsCount <= 4 ? ' заявки' : 
                   ' заявок'}. Вони позначені блакитним кольором та міткою "ваша".
                </div>
              </div>
            </div>
          )}

          <div className="card queuetable-table-card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table queuetable-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Ім'я дитини</th>
                      <th style={{ width: '160px' }}>Свідоцтво</th>
                      <th style={{ width: '140px' }}>Дата заявки</th>
                      <th style={{ width: '140px' }}>Надсилати з</th>
                      <th style={{ width: '140px' }}>Статус</th>
                      <th>Додатково</th>
                      <th style={{ width: '80px' }}>Дії</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ageGroups.map(group => 
                      renderGroup(group.id, group.title)
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex align-items-center mt-4 queuetable-pagination-wrapper">
                <div className="queuetable-pagination-info">
                  Всього {totalCount} заявки
                  {userHasRequests && (
                    <span className="text-primary ms-2">
                      (з них {userRequestsCount} ваших)
                    </span>
                  )}
                </div>
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className="page-item">
                      <a className="page-link" href="#" aria-label="Previous">
                        <span aria-hidden="true">&lt;</span>
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="#">1</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#" aria-label="Next">
                        <span aria-hidden="true">&gt;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CabinetZdoRequests;